<div class="kpa-paginator-container">
	<button
		kendoButton
		kpaKendoButton="secondary"
		[disabled]="currentQuestion === 1"
		(click)="onPrevClick()">
		Prev
	</button>
	<div>
		<p style="color: #566276">Q{{ currentQuestion }} / {{ maxPageNumber() }}</p>
	</div>
	<div class="kpa-paginator-progressbar">
		<kendo-progressbar
			[min]="minimumQuestions"
			[max]="maxPageNumber()"
			[value]="currentQuestion"
			[label]="label"></kendo-progressbar>
	</div>
	<div>
		<p style="color: #566276">Questions Per Page</p>
	</div>
	<div style="text-align: end">
		<kendo-dropdownlist
			class="kpa-paginator-itemPerPage"
			style="width: 60px; margin-right: 10px"
			[data]="questionsPerPage"
			[value]="selectedItem"
			(valueChange)="setItems($event)"
			textField="text"
			valueField="value">
		</kendo-dropdownlist>
	</div>

	<button
		*ngIf="currentQuestion < maxPageNumber()"
		kendoButton
		kpaKendoButton="secondary"
		(click)="onNextClick()">
		Next
	</button>
	<button
		*ngIf="currentQuestion === maxPageNumber()"
		kendoButton
		kpaKendoButton="primary"
		(click)="onSubmitClick()">
		Submit
	</button>
</div>
